import { defineConfig } from "rothzerg-ui";

export default defineConfig({
  theme: {
    colors: {
      primary: "#DD0024",
      primaryForeground: "#ffffff",
      secondary: "#f5f5f5",
      secondaryForeground: "#1a1a1a",
      muted: "#f5f5f5",
      mutedForeground: "#666666",
      accent: "#e8f0fe",
      accentForeground: "#003DA5",
      destructive: "#DD0024",
      destructiveForeground: "#ffffff",
      success: "#00875a",
      successForeground: "#ffffff",
      warning: "#f5a623",
      warningForeground: "#1a1a1a",
      info: "#003DA5",
      infoForeground: "#ffffff",
      background: "#ffffff",
      foreground: "#1a1a1a",
      card: "#ffffff",
      cardForeground: "#1a1a1a",
      popover: "#ffffff",
      popoverForeground: "#1a1a1a",
      border: "#e0e0e0",
      input: "#e0e0e0",
      ring: "#003DA5",
    },
    borderRadius: {
      sm: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
    },
    fonts: {
      sans: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    },
  },
  darkMode: false,
  components: {
    button: { defaultVariant: "default", defaultSize: "md" },
  },
});
